(() => {
  'use strict';
  const CODE = 'BUNDLE10', RUN = 900000, QUIET = 604800000, WAIT = 60000;
  const KEY = 'cd-offer', SINCE = 'cd-offer-since', SHUT = 'cd-offer-shut';
  const TYPES = ['IV Drips at Home', 'Lab Tests at Home'];
  if (document.querySelector('[data-cd-after]') || /\/checkouts?\//.test(location.pathname)) return;
  let long, tab;
  try { long = window.localStorage; long.setItem('cd-offer-check', '1'); long.removeItem('cd-offer-check'); tab = window.sessionStorage; tab.getItem(SINCE); } catch (e) { return; }
  const ar = (document.documentElement.lang || '').slice(0, 2) === 'ar';
  const W = ar ? {
    k: 'عرض خاص لك', one: 'أضف مغذياً أو تحليلاً ثانياً الآن ووفّر 10% على الاثنين.', two: 'خصم 10% جاهز لك. احجز الآن حتى لا يفوتك.', ends: 'ينتهي العرض خلال',
    add: 'أضف خدمة ثانية ووفّر 10%', book: 'احجز الآن ووفّر 10%', close: 'إغلاق', line1: 'أضف مغذياً أو تحليلاً ثانياً الآن ووفّر 10% على الاثنين.', line2: 'وفّرت', line3: 'بخصم 10%. احجز الآن حتى لا يفوتك.', pay: 'تدفع فقط'
  } : {
    k: 'Special offer for you', one: 'Add one more drip or lab test now and save 10% on both.', two: 'Your 10% off is ready. Book now to keep it.', ends: 'Offer ends in',
    add: 'Add one more and save 10%', book: 'Book now and save 10%', close: 'Close', line1: 'Add one more drip or lab test now and save 10% on both.', line2: 'You save', line3: 'with 10% off. Book now to keep it.', pay: 'You pay only'
  };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const now = () => Date.now();
  const get = () => { try { const o = JSON.parse(long.getItem(KEY)); return o && typeof o === 'object' ? o : {}; } catch (e) { return {}; } };
  const state = () => { const o = get(), t = now(); return Number.isFinite(o.u) && t < o.u ? 'on' : Number.isFinite(o.n) && t < o.n ? 'quiet' : 'idle'; };
  const left = () => Math.max(0, (get().u || 0) - now());
  const clock = ms => { const s = Math.ceil(ms / 1000); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); };
  const money = c => { const v = c / 100, t = v.toLocaleString('en-US', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }); return ar ? t + ' درهم' : 'AED ' + t; };
  const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; };
  const call = (path, body) => fetch(root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } }).then(r => r.json());
  const free = () => document.visibilityState === 'visible' && !document.querySelector('dialog[open]');
  let card = null, line = null, timer = 0, tick = 0, busy = false, again = false, view = null;

  function style() {
    if (document.getElementById('cdo-style')) return;
    const s = el('style'); s.id = 'cdo-style';
    s.textContent = '.cdo-card{position:fixed;z-index:44;inset-inline:12px;bottom:calc(90px + env(safe-area-inset-bottom,0px));display:grid;grid-template-columns:minmax(0,1fr) auto;gap:2px 12px;align-items:start;box-sizing:border-box;padding:14px 16px 16px;border-radius:20px;background:linear-gradient(112deg,#0e2c3d,#00456b);background:var(--cd-aura,linear-gradient(112deg,#0e2c3d,#00456b));color:#fff;box-shadow:0 14px 34px rgba(0,30,50,.34);animation:cdo-in .45s cubic-bezier(.2,.9,.3,1)}.cdo-card[hidden]{display:none}body:has(dialog[open]) .cdo-card{display:none}.cdo-k{grid-column:1;margin:0;font-size:14px;font-weight:800;line-height:1.3;color:#50e6af}.cdo-t{grid-column:1;margin:0;font-size:16px;font-weight:700;line-height:1.35;color:#fff;text-wrap:balance}.cdo-c{grid-column:1;margin:4px 0 0;font-size:14px;line-height:1.3;color:#d5e7f2}.cdo-c b{font-size:17px;font-variant-numeric:tabular-nums;color:#fff}.cdo-x{grid-column:2;grid-row:1/span 2;justify-self:end;display:grid;place-items:center;width:44px;height:44px;margin:-8px -10px 0 0;padding:0;border:0;border-radius:50%;background:none;color:#d5e7f2;font-size:24px;line-height:1;cursor:pointer}[dir=rtl] .cdo-x{margin:-8px 0 0 -10px}.cdo-go{grid-column:1/-1;min-height:48px;margin:10px 0 0;padding:10px 16px;border:0;border-radius:14px;background:#50e6af;color:#0e2c3d;font:inherit;font-size:16px;font-weight:800;line-height:1.2;cursor:pointer}.cdo-go:focus-visible,.cdo-x:focus-visible{outline:3px solid #fff;outline-offset:2px}.cdo-line{margin:12px 0 0;padding:12px 14px;border-radius:14px;background:#e9faf3;color:#0e2c3d;font-size:15px;line-height:1.45}.cdo-line b{font-variant-numeric:tabular-nums}.cdo-line strong{display:block;margin-top:2px;font-size:16px;font-weight:800}@keyframes cdo-in{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}@media (prefers-reduced-motion:reduce){.cdo-card{animation:none}}@media (min-width:900px){.cdo-card{inset-inline:auto 28px;width:380px}}';
    document.head.appendChild(s);
  }
  function hide() {
    clearInterval(tick); tick = 0; view = null;
    if (card) card.hidden = true;
    if (line) line.hidden = true;
  }
  function draw() {
    if (!view) return;
    const ms = left();
    if (ms <= 0) { hide(); run(); return; }
    const t = clock(ms), two = view.n >= 2;
    if (card && !card.hidden) {
      card.querySelector('.cdo-t').textContent = two ? W.two : W.one;
      card.querySelector('.cdo-c b').textContent = t;
      card.querySelector('.cdo-go').textContent = two ? W.book : W.add;
    }
    if (line && !line.hidden) {
      line.textContent = '';
      if (view.saved > 0) { line.append(W.line2 + ' ' + money(view.saved) + ' ' + W.line3 + ' ' + W.ends + ' ', el('b', '', t), '.', el('strong', '', W.pay + ' ' + money(view.total))); }
      else line.append(W.line1 + ' ' + W.ends + ' ', el('b', '', t), '.');
    }
  }
  function show(n, saved, total) {
    style();
    view = { n, saved, total };
    if (!card) {
      card = el('aside', 'cdo-card'); card.setAttribute('aria-live', 'polite');
      const x = el('button', 'cdo-x', '×'); x.type = 'button'; x.setAttribute('aria-label', W.close);
      const c = el('p', 'cdo-c'); c.append(W.ends + ' ', el('b'));
      const go = el('button', 'cdo-go'); go.type = 'button';
      card.append(el('p', 'cdo-k', W.k), x, el('p', 'cdo-t'), c, go);
      x.addEventListener('click', () => { try { tab.setItem(SHUT, String(get().u || 0)); } catch (e) {} card.hidden = true; });
      go.addEventListener('click', () => {
        if (view && view.n >= 2 && window.cdCare && typeof window.cdCare.open === 'function') { window.cdCare.open(); return; }
        const sheet = document.querySelector('[data-cdq-sheet]');
        if (sheet && !sheet.open) { try { sheet.showModal(); } catch (e) { sheet.setAttribute('open', ''); } }
      });
      document.body.appendChild(card);
    }
    let shut = 0; try { shut = Number(tab.getItem(SHUT)) || 0; } catch (e) {}
    card.hidden = shut === (get().u || 0);
    const row = document.querySelector('#cdb-root .cdg-total-row');
    if (row) {
      if (!line || !line.isConnected) { line = el('p', 'cdo-line'); line.setAttribute('role', 'status'); row.before(line); }
      line.hidden = false;
    }
    draw();
    if (!tick) tick = setInterval(draw, 1000);
  }
  const codes = (cart, withIt) => { const list = (cart.discount_codes || []).map(d => d.code).filter(c => c !== CODE); if (withIt) list.push(CODE); return list.join(','); };
  async function run() {
    if (busy) { again = true; return; }
    busy = true; clearTimeout(timer);
    try {
      let cart = await call('cart.js');
      const n = cart.items.filter(i => TYPES.includes(i.product_type)).reduce((s, i) => s + i.quantity, 0);
      const has = (cart.discount_codes || []).some(d => d.code === CODE);
      let s = state();
      if (s === 'idle') {
        if (n > 0) {
          let since = Number(tab.getItem(SINCE)) || 0;
          if (!since) { since = now(); tab.setItem(SINCE, String(since)); }
          const wait = WAIT - (now() - since);
          if (wait <= 0 && free()) { const t = now(); long.setItem(KEY, JSON.stringify({ u: t + RUN, n: t + RUN + QUIET })); s = state(); }
          else timer = setTimeout(run, Math.max(1500, wait + 100));
        } else tab.removeItem(SINCE);
      }
      if (s === 'on') {
        if (n >= 2 && !has) cart = await call('cart/update.js', { discount: codes(cart, true) });
        else if (n < 2 && has) cart = await call('cart/update.js', { discount: codes(cart, false) });
        const ok = (cart.discount_codes || []).some(d => d.code === CODE && d.applicable);
        if (n > 0 && (n < 2 || ok)) show(n, ok ? cart.total_discount : 0, cart.total_price); else hide();
        timer = setTimeout(run, left() + 300);
      } else {
        if (has) await call('cart/update.js', { discount: codes(cart, false) });
        hide();
      }
    } catch (e) {} finally { busy = false; if (again) { again = false; run(); } }
  }
  document.addEventListener('cd:care', () => run());
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') run(); });
  window.addEventListener('pageshow', e => { if (e.persisted) run(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
})();
